"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = require("@angular/forms");
var i0 = require("@angular/core");
var FormControlService = /** @class */ (function () {
    function FormControlService() {
    }
    FormControlService.prototype.toFormGroup = function (fields) {
        var group = {};
        fields.forEach(function (field) {
            var syncValidators = [];
            if (field.fieldTypeName === 'Skill Dropdown') {
                syncValidators.push(forms_1.Validators.required);
            }
            if (field.mappingFieldName === 'Email') {
                syncValidators.push(forms_1.Validators.pattern('^[^@]+@([^@\.]+\.)+[^@\.]+$'));
            }
            group[field.rowId] = new forms_1.FormControl('', syncValidators);
        });
        return new forms_1.FormGroup(group);
    };
    FormControlService.prototype.addFormControl = function (formGroup, controlName, required) {
        if (required === void 0) { required = false; }
        var syncValidators = [];
        if (required)
            syncValidators.push(forms_1.Validators.required);
        var control = new forms_1.FormControl('', syncValidators);
        formGroup.addControl(controlName, control);
    };
    FormControlService.prototype.isRequiredControl = function (abstractControl) {
        if (abstractControl.validator) {
            var validator = abstractControl.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
        if (abstractControl['controls']) {
            for (var controlName in abstractControl['controls']) {
                if (abstractControl['controls'][controlName]) {
                    if (this.isRequiredControl(abstractControl['controls'][controlName])) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    FormControlService.ngInjectableDef = i0.defineInjectable({ factory: function FormControlService_Factory() { return new FormControlService(); }, token: FormControlService, providedIn: "root" });
    return FormControlService;
}());
exports.FormControlService = FormControlService;
